//  Sizes for imported item images - here's why the sizes are what they are
//  Ref: https://colorlib.com/wp/size-of-the-instagram-picture/
//  x, y is maximum width/height
const imageSizes = {
	items: [
		{
			type: 'original'
		},
		{
			type: 'full',
			x: 1080,
			y: 1080
		},
		{
			type: 'half',
			x: 540,
			y: 540
		},
		{
			type: 'quarter',
			x: 270,
			y: 270
		},
		{
			type: 'twentieth',
			x: 54,
			y: 54
		}
	],
	useruploadedimages: [
		{
			type: 'original'
		},
		{
			type: 'full',
			x: 1080,
			y: 1080
		},
		{
			type: 'half',
			x: 540,
			y: 540
		},
		{
			type: 'quarter',
			x: 270,
			y: 270
		},
		{
			type: 'twentieth',
			x: 54,
			y: 54
		}
	],
	brands: [
		{
			type: 'original'
		},
		{
			type: 'header',
			x: 100
		}
	]
}
module.exports = imageSizes



// WEBPACK FOOTER //
// ./src/enums/imageSizes.js